import React from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { ModelsOverview } from './components/ModelsOverview';
import { VolumesList } from './components/VolumesList';
import { BonusSection } from './components/BonusSection';
import { KitSummary } from './components/KitSummary';
import { AudienceSection } from './components/AudienceSection';
import { WhyThreeSection } from './components/WhyThreeSection';
import { StopSearchingSection } from './components/StopSearchingSection';
import { FirstThousandSection } from './components/FirstThousandSection';
import { OfferSection } from './components/OfferSection';
import { FaqSection } from './components/FaqSection';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { MobileStickyCta } from './components/MobileStickyCta';
export function App() {
  return <div className="w-full min-h-screen bg-paper font-sans text-ink" data-id="element-0" data-mp="23u9qidp62vsj">
      <Hero data-id="element-1" data-mp="3ikh8ubu2yx01" />
      <main data-id="element-2" data-mp="3ikqz80j1f669">
        <ProblemSection data-id="element-3" data-mp="3ij64oawq3n8e" />
        <ModelsOverview data-id="element-4" data-mp="3ijpet5g4t7bv" />
        <VolumesList data-id="element-5" data-mp="3mlj82snzz920" />
        <BonusSection data-id="element-6" data-mp="3ml17jjuay8oa" />
        <KitSummary data-id="element-7" data-mp="3mk852v2dm5by" />
        <AudienceSection data-id="element-8" data-mp="3mjq45l4rr2xp" />
        <WhyThreeSection data-id="element-9" data-mp="3rc9dg5wfbbwp" />
        <StopSearchingSection data-id="element-10" data-mp="3rbzlwdvqcwow" />
        <FirstThousandSection data-id="element-11" data-mp="3rcswxr1q28cu" />
        <OfferSection data-id="element-12" data-mp="3relwkmdx3sbc" />
        <FaqSection data-id="element-13" data-mp="6hp9c27i9cj" />
        <FinalCta data-id="element-14" data-mp="4ww9qvjiygs" />
      </main>
      <Footer data-id="element-15" data-mp="82lr78302d1" />
      <MobileStickyCta data-id="element-16" data-mp="7stte3h7l4p" />
    </div>;
}